import { faClockThreeThirtySolid, FaIcon } from '@/lib/fa'
import React from 'react'
import { useEditBusinessTripForm } from '../../../../context/EditBusinessTripFormContext'
import CheckboxWithLabelField from '@/modules/drivers/forms/contract/inputs/CheckboxWithLabelField'
import { DateField } from '@/ui/form/controls/DateField'
import { MonthField } from '@/ui/form/controls/MonthField'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const SettleStage = () => {
  const { t } = useLocalize()
  const { data, setData } = useEditBusinessTripForm()

  const getTodayString = () => {
    const now = new Date()
    const y = now.getFullYear()
    const m = String(now.getMonth() + 1).padStart(2, '0')
    const d = String(now.getDate()).padStart(2, '0')
    return `${y}-${m}-${d}`
  }

  const handleIsSettledChange = (checked: boolean) => {
    if (checked) {
      const today = getTodayString()
      const match = today.match(/^(\d{4})-(\d{2})/)
      const monthValue = match ? `${match[1]}-${match[2]}-01` : today
      setData((prev: any) => ({
        ...prev,
        isSettled: true,
        calculationDate: prev?.calculationDate || today,
        settlementMonth: prev?.settlementMonth || monthValue,
        exchangeRateDate: prev?.exchangeRateDate || today,
      }))
    } else {
      setData((prev) => ({ ...prev, isSettled: false }))
    }
  }

  const handleCalculationDateChange = (date: string | null) => {
    if (!date) {
      setData((prev: any) => ({ ...prev, calculationDate: date }))
      return
    }
   
    const match = date.match(/^(\d{4})-(\d{2})/)
    const settlementMonth = match ? `${match[1]}-${match[2]}-01` : date
    setData((prev: any) => ({
      ...prev,
      calculationDate: date,
      settlementMonth,
      exchangeRateDate: date,
    }))
  }

  const handleSettlementMonthChange = (date: string | null) => {
    setData((prev: any) => ({ ...prev, settlementMonth: date }))
  }

  return (
    <div className="tw-flex tw-items-start tw-justify-between">
      <div className="tw-jusit tw-flex tw-flex-[1] tw-items-center tw-gap-2 tw-font-medium tw-text-content-base">
        <FaIcon icon={faClockThreeThirtySolid} className="tw-max-w-[12px]" />
        <p className="tw-text-sm tw-font-semibold tw-text-content-base">
          {t('businessTrip.settlement')}
        </p>
      </div>

      <div className="tw-flex tw-flex-[2] tw-flex-col tw-gap-2">
        <CheckboxWithLabelField
          field="isSettled"
          data={data}
          setData={setData}
          noPadding
          background={false}
          label={t('businessTrip.settled')}
          onChange={handleIsSettledChange}
        />
        {data?.isSettled && (
          <>
            <DateField
              label={t('businessTrip.settlement-date')}
              value={data?.calculationDate as any}
              setValue={handleCalculationDateChange}
            />
            <MonthField
              label={t('businessTrip.settlement-month')}
              value={data?.settlementMonth as any}
              setValue={handleSettlementMonthChange}
            />
          </>
        )}
      </div>
    </div>
  )
}

export default SettleStage
